<template>

    <v-layout col justify-start>
      <v-flex xs10 mx-0>
        <v-autocomplete  v-model="unitWork.select" :items="unitWork.units" item-text="name" item-value="id"
          :label="prompt" :auto-select-first='true' v-focus autofocus
          :search-input.sync="unitSearch" :loading="unitWork.loading"   return-object  @change="unitChange()">     
        </v-autocomplete>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delUnit()'>delete</v-icon>
      </v-flex>
    </v-layout>    

</template>        

<script>
import UnitService from "@/services/UnitService" ;

export default {

  components: { UnitService },
  props: {
    unit: null,
    prompt: null
  },

  data () {
    return {
      addSeqForRid: -1,
      unitWork: {
        select: {id: -1, name: "", count: -1}, 
        units: [],
        loading: false,
        origId: -1,
        pendingSearch: null
      },
      unitSearch: null  
    }
  },

  watch: {

    async unitSearch (val) {
      if (val && val !== this.unitWork.select.name && (val.length >= 2)) 
        this.error = await this.executeUnitSearch(val, this.unitWork) ;      
    }   
  },

  async created () {
    // console.log("IIIIIIIn editUnit unit= " + JSON.stringify(this.unit)) ;
    this.updateUnitSelectionFromRecord(this.unitWork, this.unit) ;
  },

  methods: {

    updateUnitSelectionFromRecord (locp, dbu) {

      if (dbu && dbu.rid) {  
        locp.select.id = dbu.id ; 
        locp.select.name = dbu.v ;
        
        locp.origId =  locp.select.id ;
        locp.units = [ locp.select ] ;        
      }
    },

    async executeUnitSearch (val, locp) {

      if (locp.loading) {
        console.log("executeUnitSearch in progress - deferring " + val) ;
        locp.pendingSearch = val ;
        return ;
      }

      let searchErr = null ;

      console.log("unitQuerySelections val: " + val) ;
      locp.loading = true ;
      try {
        const response = await UnitService.index(val, 0, 1000) ;
        console.log("UnitService responsed") ; // + JSON.stringify(response)) ;

        const d = response.data ;
        for (let i = 0 ; i < d.length ; i++) {
          const du = d[i] ;
          du.name += " - " + du.count + ((du.count === 1) ? " person" : " people") ;
        }
        locp.units = response.data ;
      }
      catch (err) {
        console.log("unitQuerySelections catch err:" + JSON.stringify(err)) ;
        searchErr = err.response.data.error ;
      }
      finally {
        locp.loading = false ;
      }

      if (locp.pendingSearch) {
        const queuedSearch = locp.pendingSearch ;
        locp.pendingSearch = null ;
        console.log("Queuing pending search.." + queuedSearch) ;
        const res = await this.executeUnitSearch(queuedSearch, locp) ;
        return res ;
      }        
      else return searchErr ;      
    },

    unitChange () {
      console.log("---------------------------------unitChange: " + JSON.stringify(this.unitWork.select)) ;
      this.unit.newId = this.unitWork.select.id ;
    },

    delUnit () {
      this.unit.newId = -1 ;
      this.unitWork.select.id = -1 ;
      this.unitWork.select.name = "*DELETED*" ;
      this.unitWork.units = [{id:-1, name:"*DELETED*"}] ;
    }
  } 
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Person/EditUnit.vue